import {
  getContractorBadgeVerificationsQuerySchema,
  type GetContractorBadgeVerificationsResponse,
  getContractorBadgeVerificationsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { get } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type QueryClient, useQuery, type UseQueryResult } from "@tanstack/react-query";

import { CONTRACTOR_BADGE_VERIFICATIONS_URL } from "../constants";

function getQueryParams(shiftId: string) {
  return {
    filter: {
      shiftId: {
        eq: shiftId,
      },
    },
  };
}

export function getContractorBadgeVerificationQueryKey(shiftId: string) {
  return [CONTRACTOR_BADGE_VERIFICATIONS_URL, getQueryParams(shiftId)] as const;
}

export async function invalidateContractorBadgeVerification(
  queryClient: QueryClient,
  shiftId: string
): Promise<void> {
  await queryClient.invalidateQueries({
    queryKey: getContractorBadgeVerificationQueryKey(shiftId),
  });
}

interface UseGetContractorBadgeVerificationOptions {
  enabled?: boolean;
}

export function useGetContractorBadgeVerification(
  shiftId: string,
  options: UseGetContractorBadgeVerificationOptions = {}
): UseQueryResult<GetContractorBadgeVerificationsResponse> {
  return useQuery({
    queryKey: getContractorBadgeVerificationQueryKey(shiftId),
    queryFn: async () => {
      const response = await get({
        url: CONTRACTOR_BADGE_VERIFICATIONS_URL,
        queryParams: getQueryParams(shiftId),
        requestSchema: getContractorBadgeVerificationsQuerySchema,
        responseSchema: getContractorBadgeVerificationsResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.BADGE_VERIFICATION_GET_FAILURE,
    },
    ...options,
  });
}
